import "./App.css";
import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "./Components/Login";
import Home from "./Container/Home";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const User = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : localStorage.clear();

    if (!User) navigate('/login');
  }, []);

  return (
    <GoogleOAuthProvider clientId={`${process.env.REACT_APP_GOOGLE_API_TOKEN}`}>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="/*" element={<Home />} />
      </Routes>
    </GoogleOAuthProvider>
  );
}

export default App;
